import {
  CORE, gatewayShortJson, gateway,
} from '../../api';

export function findUsuariosPermitidos() {
  return gatewayShortJson.get(`${CORE}/controle-bordero/usuarios`);
}
export function findResumoMensal(dataInicio, dataFinal) {
  const params = {
    dataInicio,
    dataFinal,
  };
  return gateway.get(`${CORE}/controle-bordero/resumo-mensal`, { params });
}
export function findMapaBordero(dataBase, idUsuario) {
  const params = {
    dataBase,
    idUsuario,
  };
  return gateway.get(`${CORE}/controle-bordero/mapa-bordero`, { params });
}
export function findControleDeEntrada(dataInicio, dataFinal, idUsuario) {
  const params = {
    dataInicio,
    dataFinal,
    idUsuario,
  };
  return gateway.get(`${CORE}/controle-bordero/controle-de-entrada`, { params });
}
export function findControleDeEntradaAgrupado(dataInicio, dataFinal, idUsuario) {
  const params = {
    dataInicio,
    dataFinal,
    idUsuario,
  };
  return gateway.get(`${CORE}/controle-bordero/controle-de-entrada/agrupado`, { params });
}
